import React, { useRef, useEffect, useState } from 'react'
import { AnimatePresence, motion, useScroll, useTransform, useSpring } from 'framer-motion'
import galantisJumpTop from "../assets/galantisjumptop2.png"
import galantisJumpBottom from "../assets/galantisjumpbottom.jpg"
import "../css/about.css"
import { useInView } from 'react-intersection-observer'
import Footer from './Footer'
import Copyright2 from './Copyright2'
import ByManta from './ByManta'
import flag from "../assets/car2000.webp"
import contactsvg from '../assets/about.svg'
import ScrollDown from './ScrollDown'

import PharmacyText from './PharmacyText'
// import PbjText from './PbjText'
import ReleasesContainer from './ReleasesContainer'
import delorian from "../assets/delorian1.jpg"
import PharmacyMid from "../assets/pharmacymid.jpg"
import AviaryMid from "../assets/aviarymid.jpg"
import ChurchMid from "../assets/churchmid.jpg"
import RunawayMid from "../assets/runawaymid.jpg"
import FaithMid from "../assets/faithmid.jpg"
import NoMoneyMid from "../assets/nomoneymid.jpg"
import DamnMid from "../assets/rxmid.jpg"
import HeartbreakMid from "../assets/heartbreakmid2.jpg"
import YouMid from "../assets/youmid.jpg"
import PBJMid from "../assets/pbjmid.jpg"

const About = ({ windowWidth }) => {

const targetRef = useRef()
const contentRef = useRef()
const innerRef = useRef(null) 
const spacerRef = useRef()

const { scrollY } = useScroll();

  // Smooth the scroll
const smoothY = useSpring(scrollY, {
    damping: 40,
    stiffness: 200,
    mass: 0.2,
});

const inverted = useTransform(smoothY, v => -v)


const { ref: trigger1, inView: christian } = useInView()
const { ref: trigger2, inView: billions } = useInView()
const { ref: trigger3, inView: pharmacy } = useInView()
const { ref: trigger32, inView: pharmacyt2 } = useInView()
const { ref: trigger33, inView: pharmacyt3 } = useInView()
const { ref: trigger34, inView: pharmacyt4 } = useInView()
const { ref: trigger35, inView: pharmacyt5 } = useInView()
const { ref: trigger36, inView: pharmacyt6 } = useInView()
const { ref: trigger362, inView: pharmacyt62 } = useInView()
const { ref: trigger37, inView: pharmacyt7 } = useInView()


let title = {
  closed: { opacity: 1 },
  open: { opacity: 1, transition: { delayChildren: 1.2, staggerChildren: 0.1 }}
}

let letters = {
  closed: { y: "24vw" },
  open: { y: 0, transition: { duration: 1, ease: [0.5, 0.7, 0.05, 1] } }
}

const { scrollYProgress } = useScroll({
  target: targetRef,
  offset: ["start start", "end start"]
})



const about1 = { open: { opacity: 1, transition: { duration: 1.4, delay: 1 }}, closed: { opacity: 0, transition: { duration: 1 } } }
const scaling1 = { open: { scale: 1.35, transition: { duration: 1.4 }}, closed: { scale: 1, transition: { duration: 1, delay: 0.2 } } }
const scaling2 = { open: { scale: 1.35, x: "-15vw", transition: { duration: 1.4 }}, closed: { scale: 1, x: "0vw", transition: { duration: 1, delay: 0.2 } } }
const christian1 = { open: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 1.1 } }, closed: { opacity: 0, y: 10  } }
const christian2 = { open: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 1.2 } }, closed: { opacity: 0, y: 10  } }
const christian3 = { open: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 1.3 } }, closed: { opacity: 0, y: 10  } }
const christian4 = { open: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 1.4 } }, closed: { opacity: 0, y: 10  } }
const christian5 = { open: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 1.5 } }, closed: { opacity: 0, y: 10  } }
const christian6 = { open: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 1.6 } }, closed: { opacity: 0, y: 10  } }
const billions0 = { open: { opacity: 1, transition: { duration: 0.5, delay: 0.5 } }, closed: { opacity: 0, transition: { duration: 0.5 }}}
const billions1 = { open: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.6 } }, closed: { opacity: 0, y: 10 } }
const billions2 = { open: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.7 } }, closed: { opacity: 0, y: 10 } }
const billions3 = { open: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.8 } }, closed: { opacity: 0, y: 10 } }
const billions4 = { open: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.9 } }, closed: { opacity: 0, y: 10 } }
const billions5 = { open: { opacity: 1, transition: { duration: 0.5 }}, closed: { opacity: 0, transition: { duration: 0.7 }} }
const pharmacy1 = { open: { height: "100vh", transition: { duration: 1.2 } }, closed: { height: "0vh", transition: { duration: 0.8, ease: "linear" }}}
const pharmacy2 = { open: { y: -100, transition: { duration: 1.2 } }, closed: { y: 0, transition: { duration: 0.8 }}}
const pharmacy3 = { open: { y: -180, transition: { duration: 1.2 } }, closed: { y: 0, transition: { duration: 0.8 }}}
const pharmacyText2 = { open: { opacity: 1, transition: { duration: 1.2 } }, closed: { opacity: 0, transition: { duration: 0.8 }}}
const textShift = { open: { y: "-120vh", transition: { duration: 2, delay: 0.3, ease: [0.5, 0.7, 0.05, 0.9] }}, closed: {y: 0, transition: { duration: 2, ease: [0.5, 0.7, 0.05, 0.9] }} }
const pharmacyInitialText = { open: { opacity: 1, y: 0, transition: { duration: 1.4, delay: 1.5, ease: [0.5, 0.7, 0.05, 0.9] } }, closed: { opacity: 0, y: 500, transition: { duration: 0.8, ease: [0.5, 0.7, 0.05, 0.9] }}}
const history1 = { open: { height: "100vh", transition: { duration: 1.2, delay: 1.2, ease: [0.5, 0.7, 0.05, 0.9] } }, closed: { height: "0", transition: { duration: 0.8, ease: "linear" }}}
const history2 = { open: { height: "100vh", transition: { duration: 1.2, delay: 2.2, ease: [0.5, 0.7, 0.05, 0.9] } }, closed: { height: "0", transition: { duration: 0.8, ease: "linear" }}}
const history3 = { open: { opacity: 1, transition: { duration: 1, delay: 3.5, ease: [0.5, 0.7, 0.05, 0.9] } }, closed: { opacity: 0, transition: { duration: 0.3, ease: "linear" }}}
const history4 = { open: { opacity: 1, transition: { duration: 1, delay: 3.7, ease: [0.5, 0.7, 0.05, 0.9] } }, closed: { opacity: 0, transition: { duration: 0.3, ease: "linear" }}}
const y = useTransform(scrollYProgress, [0.6, 1], [0, -400])
const y2 = useTransform(scrollYProgress, [0.6, 1], [0, -600])


    return (
    <AnimatePresence mode={"wait"}>
      <div style={{ position: 'fixed' }}>
        {/* <ScrollDown /> */}
        <Copyright2 />
        <ByManta />
        <Footer /> 
        <motion.div ref={ contentRef } style={{ position: 'relative', y: inverted, width: '100vw' }}>
            <div ref={ innerRef }>
              <div className="contact-grid">
                
            
                  <div className="contact-header">

                    <motion.img ref={targetRef} initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 2.5, duration: 1 }}} className="contact-header-img" src={flag} alt="" />

                    <motion.div initial={{ y: '0%', filter: 'blur(0.5px)', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1} }} animate={{ y: '0%', filter: 'blur(5px)', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 0.5 } }} style={{ color: '#fff000', display: 'flex', position: 'absolute', justifyContent: 'center', top: '100%', width: '100%' }}>
                    </motion.div>

                    <motion.div style={{ height: 'max-content' }} className="contact-text">
                        <div style={{ display: 'flex', width: '100%', height: 'max-contact', overflow: 'hidden' }}>
                          <motion.img src={ contactsvg } initial={{ y: '180%' }} animate={{ y: '0%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 1 }  }} style={{ width: '100%', height: 'auto' }} />
                        </div>
                      <div style={{ height: '14px', position: 'absolute', bottom: -18, left: 0, overflow: 'hidden' }}>
                        <motion.h5 initial={{ y: '100%' }} animate={{ y: '0%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 1.6 } }} style={{ marginTop: '-2px' }}>"SLEEPLESS NIGHTS</motion.h5>
                      </div>
                      <div style={{ height: '14px', position: 'absolute', bottom: -18, right: 0, overflow: 'hidden' }}>
                        <motion.h5 initial={{ y: '100%' }} animate={{ y: '0%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 1.8 } }} style={{ marginTop: '-2px' }}>AT THE CHATEAU"</motion.h5>
                      </div>
                    </motion.div>

                  </div>
          
                  <div className="contact-section">
                      <div></div>
                      <div className="contact-content">
                        <div className='about-paragraphs'>
                          <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 3, duration: 0.5 } }}>
                            <h5>Galantis is the dance music project of Christian Karlsson (aka Bloodshy, and a member of Miike Snow), who has been at the helm of the project since its debut at the 2014 Coachella Valley Music and Arts Festival.</h5>
                            <h5>Today, the heavy-hitter has received over 11 billion cumulative worldwide streams and over 5 billion video views as the Swedish-born artist continues to evolve and shatter through the boundaries in a way that only Galantis can.</h5>
                          
                          </motion.div>
                        </div>
                      </div>
                      <div></div>
                    </div>
              </div>
            </div>
          </motion.div>
      </div>
      <div className='yo4' style={{ position: 'relative', pointerEvents: 'none' }} ref={ spacerRef }></div>
      <Footer />
    </AnimatePresence>
  )
}

export default About

